'use client';

import Link from "next/link";
import { useState } from "react";
import {
   LINK_ABOUT_US, LINK_ACCIDENT_MANAGEMENT_CLAIM, LINK_EMPLOYER_LIABILITY_INSURANCE_QUOTE,
   LINK_CAR_INSURANCE_QUOTE, LINK_CONTACT_US, LINK_FAST_FOOD_DELIVERY_INSURANCE_QUOTE,
   LINK_HOME_INSURANCE_QUOTE, LINK_MOTOR_CYCLE_INSURANCE_QUOTE,
   LINK_TAXI_INSURANCE_QUOTE,
   LINK_VAN_INSURANCE_QUOTE, LINK_BUSINESS_INSURANCE_QUOTE, LINK_HOME_CAR_DETAILS, LINK_BLOG_POSTS, LINK_AGENTS_LONDON, 
   LINK_AGENTS_BIRMINGHAM, LINK_AGENTS_OLDHAM, LINK_AGENTS_LOUGHBORO, LINK_AGENTS_MANCHESTER, LINK_AGENTS_BRADFORD, LINK_AGENTS_NEWCASTLE
} from "@constants/page-links";
import {
   LINK_TIPS_LIST
} from "@constants/page-links/tips";
import {LINK_CSR, LINK_NEWS_LIST, LINK_OUR_STORY} from "@constants/page-links/news";

let NavBarDevMenu = null;
if (process.env.NODE_ENV === 'development') {
   NavBarDevMenu = require("./nav-bar-dev-menu").default;
}

export default function NavBar(
   {
      handleNavigation,
   }
) {
   const [openDropdownKey, setOpenDropdownKey] = useState(null);

   const isDropdownOpen = (dropdownKey) => openDropdownKey === dropdownKey;

   const toggleDropdown = (dropdownKey) => {
      setOpenDropdownKey((previousKey) => (previousKey === dropdownKey ? null : dropdownKey));
   };

   const handleLinkNavigation = (href) => {
      setOpenDropdownKey(null);
      handleNavigation(href);
   };
   
   return (
      <ul className="navbar-nav">
         <li className="nav-item">
            <Link className="nav-link" href="/" onClick={() => handleLinkNavigation('/')}>
               Home
            </Link>
         </li>
         <li className="nav-item">
            <Link className="nav-link" href={LINK_ABOUT_US} onClick={() => handleLinkNavigation(LINK_ABOUT_US)}>
               About
            </Link>
         </li>
         <li
            className={`nav-item dropdown ${isDropdownOpen("quotes") ? "show" : ""}`}
         >
            <a
               className="nav-link dropdown-toggle"
               href="#"
               id="navbarDropdownMenuLink-quotes"
               role="button"
               aria-expanded={isDropdownOpen("quotes")}
               onClick={(event) => {
                  event.preventDefault();
                  toggleDropdown("quotes");
               }}
               /*onMouseEnter={() => toggleDropdown("quotes")}
               onMouseLeave={() => toggleDropdown("quotes")}*/
            >
               Quotes
            </a>
            <ul
               className={`dropdown-menu dropdown-menu-end ${isDropdownOpen("quotes") ? "show" : ""}`}
               aria-labelledby="navbarDropdownMenuLink-quotes"
            >
               <li>
                  <Link className="dropdown-item" href={LINK_CAR_INSURANCE_QUOTE}
                        onClick={() => handleLinkNavigation(LINK_CAR_INSURANCE_QUOTE)}>
                     Car Insurance Quote
                  </Link>
               </li>
               <li>
                  <Link className="dropdown-item" href={LINK_VAN_INSURANCE_QUOTE}
                        onClick={() => handleLinkNavigation(LINK_VAN_INSURANCE_QUOTE)}>
                     Van Insurance Quote
                  </Link>
               </li>
               
               
               <li>
                  <Link className="dropdown-item" href={LINK_BUSINESS_INSURANCE_QUOTE}
                        onClick={() => handleLinkNavigation(LINK_BUSINESS_INSURANCE_QUOTE)}>
                     Business Insurance Quote
                  </Link>
               </li>
               
               <li>
                  <Link className="dropdown-item" href={LINK_TAXI_INSURANCE_QUOTE}
                        onClick={() => handleLinkNavigation(LINK_TAXI_INSURANCE_QUOTE)}>
                     Taxi Insurance Quote
                  </Link>
               </li>
               
               <li>
                  <Link className="dropdown-item" href={LINK_MOTOR_CYCLE_INSURANCE_QUOTE}
                        onClick={() => handleLinkNavigation(LINK_MOTOR_CYCLE_INSURANCE_QUOTE)}>
                     Motorcycle Insurance Quote
                  </Link>
               </li>
               
               <li>
                  <Link className="dropdown-item" href={LINK_EMPLOYER_LIABILITY_INSURANCE_QUOTE}
                        onClick={() => handleLinkNavigation(LINK_EMPLOYER_LIABILITY_INSURANCE_QUOTE)}>
                     Public/Employer Liability Quote
                  </Link>
               </li>
               
               <li>
                  <Link className="dropdown-item" href={LINK_FAST_FOOD_DELIVERY_INSURANCE_QUOTE}
                        onClick={() => handleLinkNavigation(LINK_FAST_FOOD_DELIVERY_INSURANCE_QUOTE)}>
                     Fast Food Delivery Insurance Quote
                  </Link>
               </li>
               
               <li>
                  <Link className="dropdown-item" href={LINK_HOME_INSURANCE_QUOTE}
                        onClick={() => handleLinkNavigation(LINK_HOME_INSURANCE_QUOTE)}>
                     Home Insurance Quote
                  </Link>
               </li>
            
            </ul>
         </li>
         
         {/*{NavBarDevMenu ? (
            <NavBarDevMenu
               isDropdownOpen={isDropdownOpen}
               toggleDropdown={toggleDropdown}
               handleLinkNavigation={handleLinkNavigation}
            />
         ) : null}*/}
         
         <li
            className={`nav-item dropdown ${isDropdownOpen("claim") ? "show" : ""}`}
         >
            <a
               className="nav-link dropdown-toggle"
               href="#"
               id="navbarDropdownMenuLink-claims"
               role="button"
               aria-expanded={isDropdownOpen("claim")}
               onClick={(event) => {
                  event.preventDefault();
                  toggleDropdown("claim");
               }}
            >
               Claim
            </a>
            <ul
               className={`dropdown-menu dropdown-menu-end ${isDropdownOpen("claim") ? "show" : ""}`}
               aria-labelledby="navbarDropdownMenuLink-claims"
            >
               
               <li>
                  <Link className="dropdown-item" href={LINK_ACCIDENT_MANAGEMENT_CLAIM}
                        onClick={() => handleLinkNavigation(LINK_ACCIDENT_MANAGEMENT_CLAIM)}>
                     Accident Management Claim
                  </Link>
               </li>
            
            </ul>
         </li>
         
         {/* <li className="nav-item">
            <Link className="nav-link" href={LINK_HOME_CAR_DETAILS} onClick={() => handleLinkNavigation(LINK_HOME_CAR_DETAILS)}>
               Car Details
            </Link>
         </li> */}
         
         <li
            className={`nav-item dropdown ${isDropdownOpen("important_links") ? "show" : ""}`}
         >
            <a
               className="nav-link dropdown-toggle"
               href="#"
               id="navbarDropdownMenuLink-claims"
               role="button"
               aria-expanded={isDropdownOpen("important_links")}
               onClick={(event) => {
                  event.preventDefault();
                  toggleDropdown("important_links");
               }}
            >
               Important Links
            </a>
            <ul
               className={`dropdown-menu dropdown-menu-end ${isDropdownOpen("important_links") ? "show" : ""}`}
               aria-labelledby="navbarDropdownMenuLink-claims"
            >
               
               <li>
                  <Link className="dropdown-item" href="https://www.gov.uk/view-driving-licence">
                     Driving Licence Information
                  </Link>
               </li>
               
               <li>
                  <Link className="dropdown-item" href="https://www.gov.uk/get-vehicle-information-from-dvla">
                    Vehicle Information
                  </Link>
               </li>
            
            </ul>
         </li>         
         
         {/* <li
            className={`nav-item dropdown ${isDropdownOpen("resources") ? "show" : ""}`}
         >
            <a
               className="nav-link dropdown-toggle"
               href="#"
               id="navbarDropdownMenuLink-resources"
               role="button"
               aria-expanded={isDropdownOpen("resources")}
               onClick={(event) => {
                  event.preventDefault();
                  toggleDropdown("resources");
               }}
            >
               Resources
            </a>
            <ul
               className={`dropdown-menu dropdown-menu-end ${isDropdownOpen("resources") ? "show" : ""}`}
               aria-labelledby="navbarDropdownMenuLink-resources"
            >
               
               <li className="">
                  <Link className="dropdown-item" href={LINK_BLOG_POSTS} onClick={() => handleLinkNavigation(LINK_BLOG_POSTS)}>
                     Blog
                  </Link>
               </li>
               
               <li className="">
                  <Link className="dropdown-item" href={LINK_TIPS_LIST} onClick={() => handleLinkNavigation(LINK_TIPS_LIST)}>
                     Tips & Insights
                  </Link>
               </li>
               
               <li className="">
                  <Link className="dropdown-item" href={LINK_NEWS_LIST} onClick={() => handleLinkNavigation(LINK_NEWS_LIST)}>
                     Latest News
                  </Link>
               </li>
               
               <li className="">
                  <Link className="dropdown-item" href={LINK_CSR} onClick={() => handleLinkNavigation(LINK_CSR)}>
                     CSR
                  </Link>
               </li>
               
               <li className="">
                  <Link className="dropdown-item" href={LINK_OUR_STORY} onClick={() => handleLinkNavigation(LINK_OUR_STORY)}>
                     Our Story
                  </Link>
               </li>
            
            </ul>
         </li> */}



         
         <li
            className={`nav-item dropdown ${isDropdownOpen("agents") ? "show" : ""}`}
         >
            <a
               className="nav-link dropdown-toggle"
               href="#"
               id="navbarDropdownMenuLink-agents"
               role="button"
               data-bs-toggle="dropdown"
               aria-expanded={isDropdownOpen && 'true'}
               onClick={(event) => {
                  event.preventDefault();
                  toggleDropdown("agents");
               }}
            >
               Our Agents
            </a>


            
            <ul
               className={`dropdown-menu dropdown-menu-end ${isDropdownOpen("agents") ? "show" : ""}`}
               aria-labelledby="navbarDropdownMenuLink-agents"
            >
               
               <li>
                  <Link className="dropdown-item" href={LINK_AGENTS_LONDON}
                        onClick={() => handleNavigation(LINK_AGENTS_LONDON)}>
                    Cheapest car insurance in london
                  </Link>
               </li>
               <li>
                  <Link className="dropdown-item" href={LINK_AGENTS_BIRMINGHAM}
                        onClick={() => handleNavigation(LINK_AGENTS_BIRMINGHAM)}>
                    Cheapest car insurance in birmingham
                  </Link>
               </li>
               <li>
                  <Link className="dropdown-item" href={LINK_AGENTS_OLDHAM}
                        onClick={() => handleNavigation(LINK_AGENTS_OLDHAM)}>
                    Cheapest car insurance in Oldham
                  </Link>
               </li>
               <li>
                  <Link className="dropdown-item" href={LINK_AGENTS_LOUGHBORO}
                        onClick={() => handleNavigation(LINK_AGENTS_LOUGHBORO)}>
                    Cheapest insurance in Leicester and Loughborough
                  </Link>
               </li>
               <li>
                  <Link className="dropdown-item" href={LINK_AGENTS_MANCHESTER}
                        onClick={() => handleNavigation(LINK_AGENTS_MANCHESTER)}>
                    Cheapest car insurance in Manchester
                  </Link>
               </li>
               <li>
                  <Link className="dropdown-item" href={LINK_AGENTS_BRADFORD}
                        onClick={() => handleNavigation(LINK_AGENTS_BRADFORD)}>
                    Cheapest car insurance in Bradford
                  </Link>
               </li>
               <li>
                  <Link className="dropdown-item" href={LINK_AGENTS_NEWCASTLE}
                        onClick={() => handleNavigation(LINK_AGENTS_NEWCASTLE)}>
                    Cheapest Car Insurance in Newcastle
                  </Link>
               </li>
            
            </ul>
         </li>
         <li className="nav-item">
            <Link className="nav-link" href={LINK_CONTACT_US} onClick={() => handleLinkNavigation(LINK_CONTACT_US)}>
               Contact
            </Link>
         </li>
      </ul>
   );
   
}